module.exports = __webpack_public_path__ + "img/logistics_bg.a10bc754.jpg";